<template>
  <div class="recommend-cell">
    <router-link :to="{name:'bookshelf',params:{catid:value.catid},query:{name:value.catname}}">
      <span class="icon" :class="value.catname|icon"></span>
      <span class="title">{{value.catname}}</span>
      <span class="icon icon-right"></span>
    </router-link>
    <div class="content">
      <movie-cover class="home-movie" v-for="(item,index) in value.items" :key="index" :value="item"></movie-cover>
    </div>
  </div>
</template>
<script>
  import MovieCover from '../components/MovieCover.vue'

  export default {
    components: {MovieCover},
    props: {
      value: {}
    }
  }
</script>
<style scoped lang='scss'>
  .recommend-cell {
    margin-top: 6px;
    padding-bottom: 4px;
    background-color: $color-white;
    border-top: $style-border;
    > a {
      display: flex;
      line-height: 50px;
      padding: 0 $app-padding;
      .title {
        flex: 1;
        margin-left: $app-padding;
      }
      .icon {
        font-size: 20px;
        color: $thirdly-text-color;
      }
    }
    .content {
      padding: 0 rem(6);
      display: flex;
      > a {
        margin: 0 rem(6);
      }
    }
    @media screen and (min-width: 768px) {
      .content {
        padding: 0 rem(1.5);
        > a {
          margin: 0 rem(3.5);
        }
      }
    }

    @media screen and (min-width: 1024px) {
      .content {
        padding: 0 rem(1.5);
        > a {
          margin: 0 rem(3.5);
          width: rem(117);
          height: rem(220);
          > span {
            height: rem(159) !important;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  @media screen and (min-width: 1024px) {
    .home-movie {
      .bg {
        height: rem(159) !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Recommendation.vue?4dc30547